// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"y4","category":"y5","tab":"y6","selected":"y7","isRental":"y8"};